import React from "react"
import clsx from "clsx"
import SurveyFormFileUploadBuilder from "../../SurveyFormFileUploadBuilder/SurveyFormFileUploadBuilder"
class DocumentFormBuilderPreview extends React.Component {

  constructor(props) {
    super(props)
    this.state ={
    }
  }

   // *** Render functions *** // 

   render() {
    
    var tabClasses = clsx({
      'active': this.props.active_tab == 'preview',
      'tab-pane': true
    });
    
    return (
      <div className={tabClasses}>
        <div id="preview">
          <div className="panel panel-default" style={{position: 'sticky', top: '0px', backgroundColor:'rgba(222, 222, 222, 0.9)', zIndex:'99'}}>
            <div className="panel-body container">
              <div className="flexed" style={{ borderBottom: '1px solid #DFDFDF', marginBottom: '1rem' }}>
                <h3 className="panel-heading-text col-md-6" style={{padding:'1rem 1rem 0px', marginBottom:'1rem'}}>{this.props.title}</h3>
                <div key="add-button" className="col-md-6 content-right flexed" style={{ marginBottom: 15, paddingRight: '0px', paddingTop: '10px' }}>
                  <button onClick={this.props.step != 'submit' ? () => this.props.onChangeStep(this.props.step) : e => this.onSubmit(e)} type="button" className="btn btn-primary btn-sm">{I18n.t(this.props.step)}</button>
                </div>
              </div>
              {this.props.step == 'submit' ? 
                <div className="TermsAndConditions content-right flexed">
                  <label><span dangerouslySetInnerHTML={{__html: I18n.t('i_agree_with_user_terms')}}></span></label>
                </div>
              : null}
            </div>
          </div>
          <div style={{padding:'15px'}}>
            {this.renderFormFields(this.props.form_fields)}
          </div>
        </div>
      </div>
    )
  }

  renderFormFields(form_fields) {
    var sortedFormFields = []
    if(this.props.order.length > 0) {
      var sortedFormFields = []
      this.props.order.map((position) => {
        form_fields.map((field) => {
          if(field.id == position){
            sortedFormFields.push(field)
          }
        })
      })
    } else {
      sortedFormFields = form_fields
    }

    var formFields = sortedFormFields.map((form_field) => {
      var form_field_answer = null
      var display_only_answer = null
      var image_answer = null
      if(this.props.answers) {
        var customerAnswers = this.props.answers
        customerAnswers.map((answer) => {
          if(answer.form_field_id == form_field.id){
            if(answer.display_only_answer == true) {
              display_only_answer = answer.display_only_answer
            } else if (answer.image_answer) {
              image_answer = answer.image_answer
            } else {
              form_field_answer = answer.answer         
            }
          }
        })
      }

      if(form_field.field_type == "display_only") {
        if(form_field.required == true) { 
          return (
            <div className="col-lg-10" key={form_field.id} id={form_field.id} style={this.props.currentStepId == form_field.id ? {border: `1px solid ${this.props.property_button_background_color}`} : {}}>
              <div className="form-group">
                <label>{`${form_field.field}*`}</label>
                <div dangerouslySetInnerHTML={{ __html: form_field.display_only_text }}></div>
                <label style={display_only_answer == true ? {paddingTop:'5px', float:'right', fontFamily:'cursive'} : {paddingTop:'5px', float:'right'}}>
                  <input type="checkbox" name={form_field.field_type} disabled={display_only_answer == true ? true : false} id={form_field.id} onChange={this.props.onChangeFormFields} />
                  {` ${display_only_answer == true ? this.props.intials : I18n.t('agree')}`}
                </label>
              </div>
              <br></br>
              <hr></hr>
            </div>
          )
        } else {
          return (
            <div className="col-lg-10" key={form_field.id} id={form_field.id}>
              <div className="form-group">
                <label>{`${form_field.field}${form_field.required === true ? '*' : ""}`}</label>
                <div dangerouslySetInnerHTML={{ __html: form_field.display_only_text }}></div>
              </div>
              <br></br>
              <hr></hr>
            </div>
          )
        }
      }

      if(form_field.field_type == "signature_generator") {
        return (
          <div className="col-lg-10" key={form_field.id} id={form_field.id} style={this.props.currentStepId == form_field.id ? {border: `1px solid ${this.props.property_button_background_color}`} : {}}>
            <div className="form-group">
              <label>{I18n.t('signature_generator')}*</label>
              <input className="form-control" name={form_field.id} id={form_field.id} value={form_field_answer ? form_field_answer : ""} onChange={this.props.onChangeFormFields} placeholder="Logan Trujillo" />
              <br></br>
              <textarea className="form-control signature-generator" name={form_field.id} id={form_field.id} value={form_field_answer ? form_field_answer : ""} style={{fontFamily: 'cursive', fontSize: 'larger', textAlign: 'center'}} readOnly={true}/>
            </div>
            <br></br>
            <hr></hr>
          </div>
        )
      }

      if(form_field.field_type == "image") {
        return(
          <div className="col-lg-10" key={form_field.id} id={form_field.id} style={this.props.currentStepId == form_field.id ? {border: `1px solid ${this.props.property_button_background_color}`} : {}}>
            <div className="form-group">
              <SurveyFormFileUploadBuilder nested={true} read_only={false} onChange={this.props.onChangeFileUploadGroup ? this.props.onChangeFileUploadGroup : this.props.onChangeFileUploadGroup} file_upload_groups={image_answer ? image_answer : [{ file_uploads: [] }]} singleFile={true} form_field_id={form_field.id} form_field={form_field} />
            </div>
            <br></br>
            <hr></hr>
          </div>   
        )
      }
    });

    return (
      <div className="form-group">
        {formFields}  
      </div>
    );
  }

}

export default DocumentFormBuilderPreview